import "./CardBlock.css";

export default function CardBlock({ title, text, width = "auto" }){
  return (
    <div className="card-block" style={{ "--card-block-width": width }}>
      <h2 className="card-block-title">{title}</h2>
      <p className="card-block-text">{text}</p>
    </div>
  );
};